import { render, staticRenderFns } from "./AutoServiceDash.vue?vue&type=template&id=5c5445c8"
import script from "./AutoServiceDash.vue?vue&type=script&lang=js"
export * from "./AutoServiceDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports